import { IEditCustomerPetFormProps } from "../../CustomerDetails/interface";
import AddCustomerForms from "../AddCustomerForms";

const EditCustomerPetInfoForm: React.FC<IEditCustomerPetFormProps> = () => {
  return <AddCustomerForms addressLayout="SINGLE" forUpdate={true} layoutFor="PET" />;
};
export default EditCustomerPetInfoForm;
